import React from 'react'

// eslint-disable-next-line no-unused-vars
import { styled, Chip, ChipProps, lighten } from '@material-ui/core'
import clsx from 'clsx'
import { colors } from '@/theme'

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: 8,

  '& > .MuiChip-label': {
    // paddingTop: 4,
    fontWeight: 600,
    lineHeight: '1rem',
    fontSize: '0.65rem',
    textTransform: 'uppercase',
    fontFamily: '"Roboto", sans-serif',
  },

  // Slim
  '&.success.slim': {
    backgroundColor: lighten(theme.palette.success.main, 0.9),
    borderColor: theme.palette.success.dark,

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.success.dark,
    },
  },

  '&.warning.slim': {
    backgroundColor: lighten(theme.palette.warning.main, 0.95),
    borderColor: theme.palette.warning.dark,

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.warning.dark,
    },
  },

  '&.info.slim': {
    backgroundColor: lighten(theme.palette.info.main, 0.95),
    borderColor: theme.palette.info.dark,

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.info.dark,
    },
  },

  '&.error.slim': {
    backgroundColor: lighten(theme.palette.error.main, 0.9),
    borderColor: theme.palette.error.dark,

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.error.dark,
    },
  },

  '&.secondary.slim': {
    backgroundColor: lighten(colors.color700, 0.9),
    borderColor: colors.color700,

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: colors.color700,
    },
  },
}))

// ----------------------------------------------------------------------

/**
 * @typedef {ChipProps} StatusProps
 * @property {'default' | 'slim' } mode
 *
 *
 * @param {StatusProps} props
 * @returns
 */
export function Status(props) {
  const { mode, className, ...other } = props

  return <StyledChip {...other} className={clsx(className, mode)} />
}
